import { jbColors } from 'theme/jbColors';

const MuiAutocomplete = {
  styleOverrides: {
    inputRoot: {
      padding: '0 !important',
      borderRadius: 0,
      margin: 0,
      '&&[class*="MuiFilledInput-root"]': {
        backgroundColor: jbColors.support.greenSmoke[10],
        borderRadius: 0,
        padding: 0,
      },
    },
  },
};

export default MuiAutocomplete;
